import React, { useEffect, useState } from "react"
import { withRouter } from "react-router-dom"
import { Container, Row, Col, Card, CardHeader, CardBody, CardText } from "reactstrap"
import MetaTags from "react-meta-tags"
import Breadcrumbs from "components/Common/Breadcrumb"
import axios from "axios"
import { API_URL, sitename } from "constants/constants"
import moment from "moment"
import { FiltersCard } from "../../../components/Common/FiltersCard"
import DepositsTable from "./DepositsTable"

const Deposits = props => {
  const [depositData, setDepositData] = useState([])
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"))
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"))
  const [depositType, setDepositType] = useState("TotalPayment")

  useEffect(() => {
    call()
  }, [])

  const call = () => {
    axios({
      method: "get",
      url: `${API_URL}/admin/get-deposit?to=${toDate}&from=${fromDate}&type=${depositType === "TotalPayment" ? "TolaPayment" : depositType}`,
    })
      .then(function (response) {
        setDepositData(response?.data?.data)
      })
      .catch(function (response) {})
  }

  // Count Airtel and MTN transactions and total amounts
  const countTransactions = () => {
    let airtelTransactions = 0
    let airtelAmount = 0
    let mtnTransactions = 0
    let mtnAmount = 0

    depositData.forEach(data => {
      if (data.channel === "ZAMBIA.AIRTEL") {
        airtelTransactions++
        airtelAmount += parseInt(data.amount)
      } else if (data.channel === "ZAMBIA.MTN") {
        mtnTransactions++
        mtnAmount += parseInt(data.amount)
      }
    })

    return { airtelTransactions, airtelAmount, mtnTransactions, mtnAmount }
  }

  const { airtelTransactions, airtelAmount, mtnTransactions, mtnAmount } = countTransactions()

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Admin" breadcrumbItem="Deposits" />
          {/* <Row>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Airtel Transactions</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">{airtelTransactions}</CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Airtel Deposits</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">{airtelAmount}</CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">MTN Transactions</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">{mtnTransactions}</CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">MTN Deposits</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">{mtnAmount}</CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
        </Row> */}
          <FiltersCard
            toDate={toDate}
            fromDate={fromDate}
            setToDate={d => setToDate(d)}
            setFromDate={d => setFromDate(d)}
            call={call}
            notDisplayFilter={true}
            hideShowType={false}
          />
          <DepositsTable
            data={depositData}
            setDepositType={setDepositType}
            depositType={depositType}
            call={call}
          />
        </Container>
        
      </div>
    </React.Fragment>
  )
}

export default withRouter(Deposits)
